import { useEffect, useState } from "react";
import promotion from "../assets/dummy/DataNotice";
import Paging from "./CompPaging";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

function PromotionNotice({ getLink }) {
  const [limit, setLimit] = useState(10); // eslint-disable-line no-unused-vars
  const [page, setPage] = useState(1);
  const offset = (page - 1) * limit;
  const [visibleCount, setVisibleCount] = useState(5);
  const [moreBtn, setMoreBtn] = useState(false);
  const [NoticeData, setNoticeData] = useState(
    promotion.Notice.slice(0).reverse()
  ); // eslint-disable-line no-unused-vars

  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + 10);
  };

  const handleCollapse = () => {
    setVisibleCount(5);
  };

  useEffect(() => {
    getLink(window.location.href);
  }, [getLink]);

  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  useEffect(() => {
    const savedPage = sessionStorage.getItem("noticePage");
    if (savedPage) {
      setPage(Number(savedPage));
    }
  }, []);

  useEffect(() => {
    sessionStorage.setItem("noticePage", page);
  }, [page]);

  return (
    <>
      {pc ? (
        <>
          <h2 className="basic-title">공지사항</h2>
          <div className="basic-subtitle news-subtitle">
            <p>공지 사항을 확인해주세요.</p>
          </div>
          <div className="notice-wrap">
            <div>
              <div className="notice-table on">
                <ul className="table-list">
                  <li className="table-item table-name-item">
                    <div className="small-table">번호</div>
                    <div className="table-name">제목</div>
                    <div className="small-table">작성일</div>
                  </li>
                  {promotion.Notice.slice(0)
                    .reverse()
                    .slice(offset, offset + limit)
                    .map((not) => (
                      <li className="table-item" key={not.id}>
                        <div className="small-table">{not.id}</div>
                        <div className="table-name">
                          <Link
                            to={`/promotion/notice/${not.id}`}
                            className="table-link"
                          >
                            {not.title}
                          </Link>
                        </div>
                        <div className="small-table">{not.date}</div>
                      </li>
                    ))}
                </ul>
                <div>
                  <Paging
                    total={promotion.Notice.length}
                    limit={limit}
                    page={page}
                    setPage={setPage}
                  />
                </div>
              </div>
              <div className="notice-none">
                <p className="notice-none-img"></p>
                <h3 className="notice-none-title">
                  공지사항이 등록되지 않았습니다.
                </h3>
              </div>
            </div>
            <div></div>
          </div>
        </>
      ) : (
        <div className="section-record">
          <h2 className="basic-title">공지사항</h2>
          <div className="basic-subtitle">공지 사항을 확인해주세요.</div>
          <div>
            <ul className="table-list">
              {NoticeData.slice(0, visibleCount).map((nor) => (
                <li className="table-item" key={nor.id}>
                  <div className="mobile-table-top">
                    <div className="table-company">{nor.id}</div>
                    <div className="table-year">{nor.date}</div>
                  </div>
                  <div className="table-name">
                    <Link
                      to={`/promotion/notice/${nor.id}`}
                      className="table-link"
                    >
                      {nor.title}
                    </Link>
                  </div>
                </li>
              ))}

              {visibleCount < NoticeData.length ? (
                <li className="about-history-more">
                  <button
                    onClick={handleLoadMore}
                    className="about-history-btn"
                  >
                    <span>더보기</span>
                  </button>
                </li>
              ) : (
                <li className="about-history-more">
                  <button
                    onClick={handleCollapse}
                    className="about-history-btn on"
                  >
                    <span>접기</span>
                  </button>
                </li>
              )}
            </ul>
          </div>
        </div>
      )}
    </>
  );
}

export default PromotionNotice;
